import HttpBaseService from '@/services/http/HttpBaseService'

class CollectionApiService extends HttpBaseService {

  index (collection) {
    return this.executeRequest(`/api/content/${collection}`, 'GET')
  }

  indexByTree (collection) {
    return this.executeRequest(`/api/content-by-tree/${collection}`, 'GET')
  }

  show (collection, id) {
    return this.executeRequest(`/content-api/collections/${collection}/entries/${id}`, 'GET')
  }
}

export default new CollectionApiService()
